import createCompetitionStore from "../../../stores/createCompetitionStore";
import { premierSteps, steps } from "../../../utils/constants";

export const stepTitles = {
  [premierSteps.COMPETITION_DETAILS]: 'fill your competition details below',
  [premierSteps.CONTESTANT_DETAILS]: 'Fill in your contestants details',
  [premierSteps.PAYMENT_OPTIONS]: 'Enter payout options',
  [premierSteps.SEASON_TYPE_CHOOSER]: 'Select your competition type',
  [premierSteps.SUMMARY]: 'Competition Summary'
}

export const disabledPreviousResolver = (currentStep: number) => {
  if (stepPreviousDisabledResolver[currentStep]) {
    return stepPreviousDisabledResolver[currentStep]()
  }

  return false
}

export const disabledNextResolver = (currentStep: number) => {
  if (stepNextDisabledResolver[currentStep]) {
    return stepNextDisabledResolver[currentStep]()
  }

  return false
}

const stepPreviousDisabledResolver = {
  [steps.COMPETITION_DETAILS]: () => true,
}

const stepNextDisabledResolver = {
  [steps.COMPETITION_DETAILS]: () => !createCompetitionStore.competitionCreated,
  [steps.SEASON_TYPE_CHOOSER]: () => !createCompetitionStore.subscriptionPlan && createCompetitionStore.subscriptionPlan !== 0,
  [steps.SUMMARY]: () => true
}